var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "audio",
        {
          attrs: {
            id: "orderAudios",
            hidden: "",
            src: require("../../../public/static/audio/tips.mp3"),
            controls: "controls"
          }
        },
        [_vm._v("\n    该浏览器不支持音频\n  ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }